import React, { useState, useEffect } from "react";
// import { useAuth } from "../fetches/AuthorizationFetch"; // Removed useAuth
import "../css/LoginPage.css";
import OpenEyeIcon from "../icons/OpenEyeIcon";
import ClosedEyeIcon from "../icons/ClosedEyeIcon";
import SumisniLogoIcon from "../icons/SumisniLogoIcon";
import TickIcon from "../icons/TickIcon"; // Assuming you still need this import
import { ChevronLeft, Square } from "lucide-react";
import CheckedBoxIcon from "../icons/CheckedBoxIcon";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); // State for remember me
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonActive, setIsButtonActive] = useState(false);


  useEffect(() => {
    if (email.trim() && password.trim()) {
      setIsButtonActive(true);
    } else {
      setIsButtonActive(false);
    }
  }, [email, password]);

  const handleSignIn = async () => {
    setError("");

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!password.trim()) {
      setError("Password is required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setIsLoading(true);
      // Reverted to direct fetch call as in the older version
      const response = await fetch('https://backend-sumisni.ota-technology.com/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "login": email, // Using "login" as the key for email
          "password": password
        })
      });

      if (!response.ok) {
        // Attempt to get error message from backend if available
        let serverErrorMessage = `Server returned ${response.status}: ${response.statusText}`;
        try {
            const errorData = await response.json();
            if (errorData && errorData.message) {
                serverErrorMessage = errorData.message;
            }
        } catch (e) {
            // Could not parse error response, stick with status text
        }
        throw new Error(serverErrorMessage);
      }

      const data = await response.json();
      // console.log('Login response data:', data); // For debugging

      if (data.token) {
        localStorage.setItem('accessToken', data.token);
        // console.log('Login successful!'); // For debugging
        window.location.href = '/summary'; // Redirect to summary page
      } else {
        throw new Error('No token received from login endpoint');
      }
    } catch (error) {
      console.error("Login failed:", error);
      const errorMessage =
        error.message ||
        "Failed to login. Please check your credentials and try again.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  const handleLearnMoreClick = () => {
    window.location.href = "https://google.com";
  };

  const handleRegisterClick = () => {
    window.location.href = "/registration";
  };

  return (
    <>
      <div className="flex min-h-screen">
        <div className="flex flex-col p-10 w-1/2 items-center">
          <div className="w-[400px]">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => (window.location.href = "/")}
            >
              <ChevronLeft className="w-4 h-4 " color="#A3AED0" />
              <span className="back-text">Back to landing page</span>
            </div>
          </div>
          <div className="flex-grow flex flex-col justify-center items-center w-full">
            <div className="w-[400px]">
              <div className="justify-start">
                <h1 className="sign-in-title">Sign In</h1>
                <p className="sign-in-subtitle">
                  Please input your information in the fields below to enter
                  your SUMISNI platform.{" "}
                </p>
                {error && <div className="error-message">{error}</div>}

                <div className="input-group">
                  <div className="w-full">
                    <label className="form-label">Email *</label>
                    <input
                      className="form-input"
                      placeholder="username@mail.com"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      type="email"
                    />
                  </div>

                  <div className="w-full">
                    <label className="form-label">Password *</label>
                    <div className="password-input-container">
                      <input
                        className="form-input password-input"
                        type={showPassword ? "text" : "password"}
                        placeholder="Min. 8 characters"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                      />
                      <span
                        className="password-toggle"
                        onClick={togglePasswordVisibility}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ")
                            togglePasswordVisibility();
                        }}
                      >
                        {showPassword ? <ClosedEyeIcon /> : <OpenEyeIcon />}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="my-6 w-[400px]">
                  <div className="flex items-center justify-between gap-2">
                    <button className="flex gap-2" onClick={toggleRememberMe}>
                      {rememberMe ? (
                        <CheckedBoxIcon />
                      ) : (
                        <Square
                          size={24}
                          color="#A3AED0"
                          fill="transparent"
                          strokeWidth={1.5}
                        />
                      )}
                      <span className="remember-text">Remember me</span>
                    </button>
                    <span className="forgot-password">Forget password?</span>
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <button
                    className={`w-[400px] h-[50px] rounded-[40px] ${!isButtonActive ? "bg-[#F4F7FE]" : "cursor-pointer  bg-[#4318FF]"}`}
                    onClick={handleSignIn}
                    disabled={isLoading || !isButtonActive}
                  >
                    <span className={`${isButtonActive ? "button-text-active" : "button-text"}`}>Sign In</span>
                  </button>
                  <span
                    className="create-account"
                    onClick={handleRegisterClick}
                  >
                    <p>Not registered yet?</p>
                    <p>Create an Account</p>
                  </span>
                </div>

                <div className="flex footer-text">
                  <span>
                    © 2025 SUMISNI Copyright. All Rights Reserved. Designed with
                    love <span className="font-bold">by DmitriyLeo!</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Right Section */}
        <div className="flex items-center justify-center login-right-section w-1/2">
          <div className="flex flex-col items-center h-full w-full py-10">
            <div className="flex-grow flex flex-col items-center justify-center">
              <div className="flex flex-col items-center justify-center gap-12">
                <SumisniLogoIcon className="flex items-center" />
                <button
                  className="flex flex-col border-[3px] border-white border-opacity-20 rounded-[40px] w-[470px] h-[130px] gap-1.5 items-center justify-center"
                  onClick={handleLearnMoreClick}
                >
                  <span className="learn-text">
                    Learn more about SUMISNI on
                  </span>
                  <span className="website-text">sumisni.com</span>
                </button>
              </div>
            </div>
            <div className="flex items-center justify-center gap-11">
              <a href="#" className="terms-text">
                License
              </a>
              <a href="#" className="terms-text">
                Terms of Use
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;